export default class FlickityInnerSliderOptions {
    constructor(innerSlider) {
        if (!innerSlider) return;

		let flickity_options = {};

		// Get data-flickity from HTML.
		if (innerSlider.getAttribute('data-flickity')) {
			flickity_options = JSON.parse(innerSlider.getAttribute('data-flickity'));
		}

		let flkty = new Flickity( innerSlider, flickity_options );

		doTheFunction();

		function doTheFunction() {
			if (window.innerWidth > 992) {
				let selectedElement = flkty.selectedElement;
				if (selectedElement !== null) {
					selectedElement.style.top = 0;
					selectedElement.style.opacity = 1;
					selectedElement.style.pointerEvents = 'auto';
					if (selectedElement.nextSibling !== null) {
						if (! flkty.element.classList.contains('simple-slideshow')) {
							selectedElement.nextSibling.style.top = '4rem';
						}
						selectedElement.nextSibling.style.opacity = 1;
						selectedElement.nextSibling.style.pointerEvents = 'auto';
						if (selectedElement.nextSibling.nextSibling !== null) {
							if (! flkty.element.classList.contains('simple-slideshow')) {
								selectedElement.nextSibling.nextSibling.style.top = '8rem';
							}
							selectedElement.nextSibling.nextSibling.style.opacity = 1;
							selectedElement.nextSibling.nextSibling.style.pointerEvents = 'auto';
						}
					}
					if (selectedElement.previousSibling !== null) {
						selectedElement.previousSibling.style.opacity = 0;
						selectedElement.previousSibling.style.pointerEvents = 'none';
					}
				}
			} else {
				flkty.cells.forEach((cell) => {
					cell.element.style.top = 0;
					cell.element.style.opacity = 1;
					cell.element.style.pointerEvents = 'auto';
				});
			}
		}

		flkty.on('change', function () {doTheFunction()});

		window.addEventListener('resize', doTheFunction, false);
	}
}
